import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { BuildVuPage } from 'js/liswp/build_vu/api';
import { Page } from 'js/liswp/build_vu/Page';
import { Work, WorkClaim } from './types';
import trackClick from 'js/utils/trackClick';

type SourceTextProps = {
  sourceClaim: WorkClaim;
  sortedPages: BuildVuPage[];
  sourcePaper: Work;
};

const PdfPageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs-8, 8px);
  width: 100%;
`;

const PdfPageFrame = styled.div`
  position: relative;
  width: 100%;
  border-radius: var(--corner-radius-radius-lg, 16px);
  border: 1px solid var(--stroke-light, #dddde2);
  overflow: hidden;
  box-sizing: border-box;

  > * {
    margin-bottom: 0;
  }
`;

const SourceTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs-16, 16px);
`;

const SourceText: React.FunctionComponent<SourceTextProps> = ({
  sourceClaim,
  sortedPages,
  sourcePaper,
}) => {
  return (
    <>
      {sortedPages.length > 0 && (
        <SourceTextBlock>
          <Body bold size="lg" as="h2">
            Source text
          </Body>
          <PdfPageStack>
            {sortedPages.map((page) => (
              <PdfPageFrame key={page.page_number}>
                <Page page={page} load={true} onIntersect={() => {}} />
              </PdfPageFrame>
            ))}
          </PdfPageStack>
          <ButtonLink
            href={sourcePaper.url}
            size="xs"
            fullWidth
            iconRight="arrow_forward"
            onClick={() => {
              trackClick({
                source: 'single_claim_page.source_text.see_full_paper',
                extra: {
                  source_claim_id: sourceClaim.id,
                },
              });
            }}
          >
            See full paper
          </ButtonLink>
        </SourceTextBlock>
      )}
    </>
  );
};

export default SourceText;
